import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Parallax from 'parallax-js'

export default (el, props) => {
    const $el = $(el);
    const $content = $el.find('[data-gyro-content]');
    
    let parallaxInstance;
    
    const updateScalar = () => {
        const val = Math.round(Math.max($el.width(), $el.height()) / 110);
        parallaxInstance.scalar(val, val);
    };
    
    const onResize = () => {
        updateScalar();
    };
    
    const init = () => {
        const contentParent = $content.parent();
        
        contentParent.append($content.clone().attr('data-depth', '-0.5'));
        //contentParent.append($content.clone().attr('data-depth', '0.3'));
        contentParent.append($content.clone().attr('data-depth', '0.5'));
        $content.attr('data-depth', '0');
        
        parallaxInstance = new Parallax($el.get(0), {
            relativeInput: true,
            clipRelativeInput: true,
            frictionX: 0.075,
            frictionY: 0.075
        });
        
        updateScalar();
        
        Viewport.on('resize', onResize);
    };
    
    const destroy = () => {
        parallaxInstance.destroy();
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};
